import { render, staticRenderFns } from "./InvitationGroupMemberDialog.vue?vue&type=template&id=2deaa31a"
import script from "./InvitationGroupMemberDialog.vue?vue&type=script&lang=js"
export * from "./InvitationGroupMemberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports